export const MODE = {
  BO: 'backoffice',
  FO: 'frontoffice',
  PO: 'recruiter',
} as const;

export const PARENT = {
  NETWORK: 'Network',
  GROUP: 'Topics::Topic',
} as const;
